<template >
    <div>
        <experiencia/>
    </div>
</template>

<script>
import Experiencia from '../components/experienciaComponent'
export default {
      components:{
        Experiencia
    }
}
</script>